<template>
  <div
    v-if="iscurrentPage && pageShow && envShow"
    ref="page"
    :class="['zeus-content-page', isFlow ? 'zeus-content-page-static' : '', data.name]"
    :style="getPageStyles()"
    :data-exp="`code=${data.name}_sw`"
    @click="closeBackPop($event)"
  >
    <template v-for="(component, index) in data.components">
      <component-group
        v-if="component.type == 'group'"
        :key="index"
        :data="component.children"
        :page="data"
        :site-data="siteData"
        :is-fixed-parent="isFixed && !isFixedParent"
      />
      <zeus-component
        v-else
        :key="index"
        :data="component"
        :page="data"
        :site-data="siteData"
        :is-fixed-parent="isFixed && !isFixedParent"
      />
    </template>
  </div>
</template>

<script>
import { renderBg } from '@/utils/tools'
import ComponentGroup from './componentGroup'
import { BsGetEnv, BsUtil, BsGetCid, BsGetXcx } from 'dida-web-common'
// import ComponentGroup from './componentGroup'
import ZeusComponent from './component'
export default {
  components: { ComponentGroup, ZeusComponent },
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    siteData: {
      type: Object,
      default: () => ({})
    },
    mask: Boolean
  },
  inject: ['globalConfig'],
  data() {
    return {
      fixedData: {
        position: 'absolute',
        left: 0,
        top: 0,
        width: '100%',
        // 'height': '100%',
        zIndex: 3000,
        pointerEvents: 'none'
      },
      envShow: false,
      pageShow: this.data.name === 'loading', // 页面默认需要时false
      origin: location.origin.indexOf('didachuxing.com') > -1
        ? location.origin : (BsGetEnv.isEnvOnline
            ? 'https://web.didachuxing.com'
            : BsGetEnv.isEnvECS
            ? 'https://web-simu.didachuxing.com'
            : 'https://web-test.didachuxing.com')
    }
  },
  computed: {
    layoutType() {
      return this.data?.options?.basic?.layoutType
    },
    style() {
      return this.data?.options?.style
    },
    iscurrentPage() {
      var bodyScroll = this.data?.options?.basic?.bodyScroll

      const rt = this.$root.currentRouter || 'default'
      if (rt !== 'default') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.$root.closeLoading = true
      }
      this.setEnvShow()
      var currentRoutes = this.$root.pageRouter[rt]?.indexOf(this.data?.id) > -1
      if (bodyScroll && this.envShow && this.pageShow && currentRoutes) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = ''
      }
      return currentRoutes
    },
    isFixed() {
      return this.layoutType === 'fixed'
    },
    isFlow() {
      return this.layoutType === 'static'
    },
    isMobile() {
      return window.navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
    },
    isFixedParent() {
      // 页面不存在背景图的页面
      const { color, image } = this.style.background
      if (image) return true
      if (
        !color ||
        (color && color === 'transparent') ||
        color.split(',').pop() === '0)'
      ) {
        return false
      } // 不需要fixed
      return true
    }
  },
  watch: {

  },
  async mounted() {
    this.initEvents()
    this.data.name !== 'loading' && (this.pageShow = await this.setPageShow())
  },
  created() {
    this.handlerFixedScroll()
  },
  methods: {
    // 使用固定页面做弹唱时，点击透明背景关闭弹窗
    closeBackPop(e) {
      const router = this.data?.options?.basic.pageRouter
      if (
        this.isFixed &&
        this.isFixedParent &&
        this.data?.options?.basic?.closeBackPop &&
        e.target === this.$refs.page &&
        !router
      ) {
        this.pageShow = false
      }
    },
    async setEnvShow() {
      const showPage = this.data?.options?.basic?.showPage
      const shouldShow = async() => {
        const { cid } = await BsGetCid()
        const loginCondition = showPage?.login
        return loginCondition === 1
          ? true
          : loginCondition === 2
          ? !!cid
          : loginCondition === 3
          ? !cid
          : true
      }
      if (BsUtil.isObject(showPage)) {
        const { isAli, isWx } = await BsGetXcx()
        if (
          showPage?.env === 1 || // 全部环境显示
          showPage?.env === 2 || // 全部环境隐藏
          (showPage?.env === 3 && BsGetEnv.inApplication) || // app环境显示
          (showPage?.env === 4 && (isAli || isWx)) || // 小程序环境显示
          (showPage?.env === 5 && !BsGetEnv.inApplication && !(isAli || isWx)) // H5环境展示
        ) {
           this.envShow = await shouldShow()
        } else {
          this.envShow = false
        }
      } else {
        this.envShow = true
      }
    },
    async setPageShow() {
      // 页面展示逻辑
      const showPage = this.data?.options?.basic?.showPage
      if (BsUtil.isBoolean(showPage)) return showPage
      if (showPage?.env === 1) return true
      if (showPage?.env === 2) return false // 全部环境隐藏
      return true
    },

    initEvents() {
      const action = this.data?.options?.action
      if (!action || !action.length) {
        return
      }
      const handler = (
        { handler, params = {}, options: { data } = { data: '' }},
        { ctx }
      ) => {
        const router = this.data?.options?.basic.pageRouter
        switch (handler) {
          case '$h_hide':
            this.pageShow = false
            break
          case '$h_show':
            if (router.indexOf(',') === -1 && this.$root.currentRouter !== (router || 'default')) {
              this.$root.currentRouter = router || 'default'
              if (this.$root.currentRouter.indexOf('-replace') > -1 || this.$root.currentRouter === 'default') {
                  window.history.replaceState(
                    { name: router },
                    null,
                    `${this.origin}/${this.$root.productName}/${router}${location.search}${location.hash}`
                  )
              } else {
                window.history.pushState(
                { name: router },
                null,
                `${this.origin}/${this.$root.productName}/${router}${location.search}${location.hash}`)
              }
              this.pageShow = true
              scrollTo(0, 0)
            } else {
              this.pageShow = true
            }
            break
        }
      }
      action.forEach((action) => {
        action.subscribe &&
          action.subscribe.forEach((subscribe) => {
            this.$bus.$on(subscribe, (triggerParams) => {
              handler(action, triggerParams)
            })
          })
      })
    },
    getPageStyles() {
      const fixedConfig = this.isFixed ? this.fixedData : {}
      const editAndFlowConfig =
        window.$isEditing && this.isFlow
          ? { minHeight: this.style.height + this.globalConfig.unit }
          : {}
      if (this.isFixedParent && fixedConfig.position) {
        fixedConfig.position = 'fixed'
        fixedConfig.pointerEvents = 'auto'
        // document.querySelector('body').setAttribute('style', 'overflow: hidden;')
      }
      let height = ''
      if (this.isFixed) {
        height = window.$isEditing
          ? this.style.height + this.globalConfig.unit
          : '100vh'
      } else {
        height = this.isFlow
          ? 'auto'
          : this.handlerUnit(this.style.height, this.style.fs)
      }
      return {
        height,
        overflow: window.$isEditing || this.isFixed ? 'visible' : 'hidden',
        // 'opacity': this.mask ? 0.3 : 1,
        ...renderBg(this.style.background, this.$root.isSuWebp),
        ...fixedConfig,
        ...editAndFlowConfig
      }
    },
    handlerUnit(v, fs = false) {
      if (fs) {
        return window.$isEditing ? '667px' : '100vh'
      }
      return isNaN(Number(v)) ? v : v + this.globalConfig.unit
    },
    handlerFixedScroll() {
      if (this.isFixed && !this.isMobile) {
        this.fixedData.position = 'absolute'
        window.addEventListener('scroll', () => {
          this.fixedData.top = `${
            document.documentElement.scrollTop || document.body.scrollTop
          }px`
        })
      }
    }
  }
}
</script>
